import { Component } from "react";
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { connect } from "react-redux";
import { createHChartMaps } from "layouts/mainsection/components/CHighchartToolsTraffic";
import Highcharts from "highcharts/highmaps";
window.Highcharts = Highcharts;
require("@highcharts/map-collection/custom/south-america");
class PCDTMapaIncidencias extends Component {

  componentDidMount() {}
  
  render() {
    //[{year: 2002, value: 10.5}]

    // return this.props.data.length > 0 ? (
    return true ? (
      <>
        {createHChartMaps(
          "charPCDTMapaIncidencias",
          {
            chart: {
              map: Highcharts.maps["custom/south-america"],
            },

            title: {
              text: "Incidencias",
              style: { display: "none" },
            },
            legend: {
              // enabled: false,
              title: {
                text: "",
              },
              align: "rigth",
              verticalAlign: "bottom",
              floating: true,
              labelFormatter: function () {
                // return (this.from || '<') + ' - ' + (this.to || '>');
                return this.from;
              },
              layout: "vertical",
              valueDecimals: 0,
              backgroundColor: "rgba(255,255,255,0.9)",
              // backgroundColor: 'rgba(100,100,100,0.9)',
              padding: 12,
              itemMarginTop: 0,
              itemMarginBottom: 0,
              symbolRadius: 0,
              symbolHeight: 14,
              symbolWidth: 24,
            },
            tooltip: {
              // enabled: false
            },
            colorAxis: {
              minColor: "rgba(223, 202, 181,1)",
              maxColor: "rgba(174, 36, 10,1)",
              dataClasses: [],
              // dataClasses: [
              //   {
              //     to: 0,
              //     // color: 'rgba(19,64,117,0.05)'
              // },
              // {
              //     to: 2,
              //     from: 1
              //     // color: 'rgba(19,64,117,0.05)'
              // }, {
              //     from: 3,
              //     to: 4,
              //     // color: 'rgba(19,64,117,0.2)'
              // }, {
              //     from: 5,
              //     to: 6,
              //     // color: 'rgba(19,64,117,0.5)'
              // }, {
              //     from: 7,
              //     to: 8,
              //     // color: 'rgba(19,64,117,0.8)'
              // }, {
              //     from: 9,
              //     // color: 'rgba(19,64,117,1)'
              // }]
            },

            series: [
              {
                // data:[['pe', 1], ['br', 2]],
                data: [],
                name: "Unidades",
                states: {
                  hover: {
                    enabled: false,
                    // color: '#BADA55'
                  },
                },
                dataLabels: {
                  enabled: true,
                  // format: ''
                  formatter: function () {
                    if (this.point.value) {
                      return this.point.name;
                    }
                  },
                },
              },
            ],
          },
          this.props.callback
        )}
        <div style={{ fontSize: "0.9em" }}>
          <div className="has-text-centered" style={{ fontSize: "0.9em" }}>
            <p
              className="px-6"
              style={{
                color: "#000",
                fontSize: "1.1em",

                fill: "#000",
              }}
            >
              <i>{this.props.description}</i>
            </p>
          </div>
        </div>
      </>
    ) : null;
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(
  PCDTMapaIncidencias
);
